import { PAGE_SIZE_100 } from '../../services/pagination-service';

export const SET_INITIAL_VIEW_PAGE_STATS = 'SET_INITIAL_VIEW_PAGE_STATS';

export const SET_VIEW_PAGE_AND_PAGE_SIZE = 'SET_VIEW_PAGE_AND_PAGE_SIZE';

export const setInitialViewPageStats = (viewName, page, pageSize, totalRecords) => ({
  type: SET_INITIAL_VIEW_PAGE_STATS,
  viewName,
  page,
  pageSize,
  totalRecords,
});

export const setViewPageAndPageSize = (viewName, page, pageSize) => ({
  type: SET_VIEW_PAGE_AND_PAGE_SIZE,
  viewName,
  page,
  pageSize,
});

export const SET_TOTAL_RECORDS = 'SET_TOTAL_RECORDS';
export const setTotalRecords = (viewName, totalRecords) => ({
  type: SET_TOTAL_RECORDS,
  viewName,
  totalRecords,
});

export const READ_PAGING_INFO_FROM_URL = 'READ_PAGING_INFO_FROM_URL';
export const readPagingInfoFromUrl = (viewName, defaultPageSize = PAGE_SIZE_100) => ({
  type: READ_PAGING_INFO_FROM_URL,
  viewName,
  defaultPageSize,
});
